const API_URL = process.env.REACT_APP_ENQUIRY_API || '/api/send-enquiry';

export async function sendEnquiry({ name, email, inquiryType, message, source = 'website' }) {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, inquiryType, message, source }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || 'Unable to send your enquiry. Please try again.');
  }

  return data;
}
